import { UpdateProcessInput, CreateProcessInput } from "../validation/process";
import authService from './authService';

let BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || process.env.REACT_APP_API_URL || '';

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch {
    // Use default BASE_URL from env
  }
}
loadConfig().then(() => {});

export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {
  const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to fetch");
  }
  return data;
}

export async function fetchAllDataApi(): Promise<any> {
  const response = await authService.apiCall(`${BASE_URL}/processes/getAll`, { method: "GET" });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to fetch");
  }
  return data;
}

export async function createProcessApi(body: CreateProcessInput): Promise<void> {
  const response = await authService.apiCall(`${BASE_URL}/processes`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to create");
  }
  return data;
}

export async function createProcessFromRiskApi(body: CreateProcessInput): Promise<any> {
  const response = await authService.apiCall(`${BASE_URL}/processes/fromRisk`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to create");
  }
  return data;
}

export async function updateProcessApi(id: string, body: UpdateProcessInput): Promise<void> {
  const response = await authService.apiCall(`${BASE_URL}/processes/${id}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to update");
  }
  return data;
}

export async function deleteProcessApi(id: string): Promise<void> {
  const response = await authService.apiCall(`${BASE_URL}/processes/${id}`, {
    method: "DELETE",
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to delete");
  }
  return data;
}

export async function getProCount(): Promise<any> {
  const response = await authService.apiCall(`${BASE_URL}/processes/count`, { method: "GET" });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error("Failed to fetch");
  }
  return data;
}
